import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgPipesModule } from 'ngx-pipes';

@Component({
  selector: 'app-short-content',
  standalone: true,
  imports: [CommonModule, NgPipesModule],
  templateUrl: './short-content.component.html',
  styleUrl: './short-content.component.scss',
})
export class ShortContentComponent {
  @Input() content!: string;
  @Input() length!: number;

  showMore = false;
}
